import React from 'react';
import { Box, Flex, HStack, Icon, Tooltip } from '@chakra-ui/react';
import { KText } from '@/ui-library/components/text';
import { InfoCircle } from '@kula-ai/icons/dual-tone/InfoCircle';
import { MarkdownSubtext } from '@/utils/MarkdownSubtext';

interface DetailSectionProps {
  label: string;
  children: React.ReactNode;
  tooltipLabel?: string;
  subLabel?: string;
}

export const DetailSection: React.FC<DetailSectionProps> = ({
  label,
  children,
  tooltipLabel,
  subLabel,
}) => (
  <Flex flexDir="column" gap="6px" minW="0">
    <HStack align="center">
      <KText color="primary-900" fontWeight="medium">
        {label}
      </KText>
      {tooltipLabel && (
        <Tooltip label={tooltipLabel} placement="top" hasArrow>
          <Box>
            <Icon
              as={InfoCircle}
              width="16px"
              height="16px"
              color="secondary-700"
            />
          </Box>
        </Tooltip>
      )}
    </HStack>
    {subLabel && (
      <MarkdownSubtext
        markdown={subLabel}
        bodyColor="secondary-500"
        minW={0}
      />
    )}
    {children}
  </Flex>
);
